<template>
<div>
    <div class="new-users-header">
        <span>Cargo del Usuario</span>
    </div>
    <div class="new-users-charges-type">
        <button v-bind:class="{ 'active': userData.typeUser === 1 }" v-on:click="setTypeUser(1)">
			<div class="img-superviser"></div>
			<span>Supervisor</span>
		</button>
        <button v-bind:class="{ 'active': userData.typeUser === 0 }" v-on:click="setTypeUser(0)">
			<div class="img-housemaid"></div>
			<span>Mucama</span>
		</button>
    </div>
    <div class="new-users-text">
        <v-layout>
            <v-flex xs12>
                <p style="text-align: left;">But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful.</p>
            </v-flex>
        </v-layout>
    </div>
    <form action="" class="new-users-form">
        <v-layout>
            <v-flex xs12 md10>
                <v-layout row wrap>
                    <v-flex xs12 md4>
						<label for="" class="new-users-header">Nombres</label>
						<input-text
							v-bind:label="namePlaceholder"
							v-on:input="setName"
							v-bind:value="userData.name"
							v-bind:required="true"
							></input-text>
                    </v-flex>
                    <v-flex xs12 md4>
						<label for="" class="new-users-header">Apellidos</label>
						<input-text
							v-bind:label="lastNamePlaceholder"
							v-on:input="setLastName"
							v-bind:value="userData.lastName"
							v-bind:required="true"
							></input-text>
					</v-flex>
                    <v-flex xs12 md4>
						<label for="" class="new-users-header">Fecha de nacimiento</label>
						<input-text
							v-bind:label="bornDate.placeholder"
							v-on:input="setBornDate"
							v-bind:type="bornDate.type"
							v-bind:value="userData.bornDate"
							v-bind:required="true"
							></input-text>
					</v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12 md10>
                <v-layout row wrap>
                    <v-flex xs12 md4>
						<select-button
							v-bind:label="genderLabel"
							v-bind:items="genders"
							v-on:parent-value="setGender"></select-button>
                    </v-flex>
                    <v-flex xs12 md4>
						<label for="" class="new-users-header">Correo electrónico</label>
						<input-text
							v-bind:label="email.placeholder"
							v-on:input="setEmail"
							v-bind:type="email.type"
							v-bind:value="userData.email"
							v-bind:required="true"
							></input-text>
					</v-flex>
                    <v-flex xs12 md4>
						<label for="" class="new-users-header">Confirmar correo electrónico</label>
						<input-text
							v-bind:label="confirmEmail.placeholder"
							v-on:input="setConfirmEmail"
							v-bind:type="confirmEmail.type"
							v-bind:value="userData.confirmEmail"
							></input-text>
							<small v-if="confirmEmail.noMatch" class="new-users-password">No coinciden los correos electrónicos.</small>
					</v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
		<v-layout>
            <v-flex xs12 md10>
                <v-layout row wrap>
                    <v-flex xs12 md4>
						<label for="" class="new-users-header">Contraseña actual</label>
						<input-text
							v-bind:type="password.type"
							v-on:input="setCurrentPassword"
							v-bind:disabled="password.disabledPassword"
							v-bind:value="userData.password"
							v-bind:required="true"
							></input-text>
							<small v-if="password.currentNoMatch" class="new-users-password">La contraseña introducida no coincide con la registrada.</small>
                    </v-flex>
                    <v-flex xs12 md4>
						<label for="" class="new-users-header">Nueva contraseña</label>
						<input-text
							v-bind:type="password.type"
							v-on:input="setNewPassword"
							v-bind:disabled="password.disabledNewPassword"></input-text>
					</v-flex>
                    <v-flex xs12 md4>
						<label for="" class="new-users-header">Repetir contraseña</label>
						<input-text
							v-bind:type="password.type"
							v-on:input="setConfirmPassword"
							v-bind:disabled="password.disabledNewPassword"
							></input-text>
							<small v-if="password.noMatch" class="new-users-password">No coinciden las contraseñas.</small>
							<small v-if="password.required" class="new-users-password">Debe confirmar la nueva contraseña.</small>
					</v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
		<v-layout>
			<v-flex xs12 md10>
				<v-layout row wrap>
					<v-flex xs12 md12>
						<label for="" class="new-users-header">Seleccione las sucursales</label>
					</v-flex>
					<v-flex xs12 md2>
						<v-checkbox
							label="Seleccione todas" 
							v-on:change="selectAllBranchOffices"
							v-model="allBranchOffice"
							hide-details
							class="input-checkbox"
							></v-checkbox>
					</v-flex>
					<v-flex xs12 md12>
						<v-layout row wrap>
							<v-flex v-for="branchOffice in branchOffices" 
								:key="branchOffice.id" 
								class="new-users-branch-offices"
								>
								<v-checkbox
									v-bind:label="branchOffice.name" 
									v-model="userData.branchOffices" 
									v-bind:value="branchOffice.id"
									hide-details
									class="input-checkbox"
									></v-checkbox>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout>
			<v-flex xs12 md8>
				<v-layout>
					<v-flex xs12 mb-0>
						<label for="" class="new-users-header" style="margin-bottom: 0;">Foto de perfil</label>
					</v-flex>
				</v-layout>
				<v-layout>
					<v-flex xs12>
						<div class="new-user-file-upload">
							<file-upload-container
								v-bind:label-for="'Foto-perfil'"
								v-bind:image-url="userData.imageUrl"
								v-on:upload="load"
								></file-upload-container>
						</div>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout>
			<button 
				class="new-users-save"
				v-on:click.prevent="save"
				v-bind:disabled="activeSaveButton"
				>Guardar
			</button>
		</v-layout>
    </form>

</div>
</template>
<script>
import InputText from '@/components/shared/InputText';
import SelectButton from '@/components/shared/SelectButton';
import helper from '@/shared/helper';
import mixin from '@/shared/mixins';
import FileUploadContainer from '@/components/shared/FileUpload/FileUploadContainer';

const helperData = helper.data();

function load(url) {
	this.showNotification('Carga exitosa', 'success');
	this.userData.imageUrl = url;
}

async function created() {
	this.id = this.$route.params.userId;
	const urlBranchOffice = 'subsidiary-simple-list';
	const res = await this.$http.get(urlBranchOffice);
	this.branchOffices = res.data;

	if (this.id) {
		this.previewImage = true;
		this.disabledSaveButton = false;
		const url = `housemaid/${this.id}`;
		const response = await this.$http.get(url);
		this.userData = {
			name: response.data.name,
			lastName: response.data.lastname,
			email: response.data.email,
			confirmEmail: response.data.email,
			typeUser: response.data.flag_supervisor,
			gender: response.data.gender,
			bornDate: response.data.date_birth,
			branchOffices: response.data.subsidiaries,
			imageUrl: response.data.url_image,
		};
		if (this.userData.branchOffices === null) {
			this.userData.branchOffices = [];
		}
		if (this.userData.gender === 1) {
			this.genderLabel = 'Hombre';
		} else if (this.userData.gender === 2) {
			this.genderLabel = 'Mujer';
		} else {
			this.genderLabel = 'Genero';
		}
	} else {
		this.previewImage = false;
		this.password.disabledPassword = true;
		this.disabledSaveButton = true;
	}
}

function setTypeUser(type) {
	if (type === 1) {
		this.userData.typeUser = 1;
	} else {
		this.userData.typeUser = 0;
	}
}
function setName(value) {
	this.userData.name = value;
}
function setLastName(value) {
	this.userData.lastName = value;
}
function setBornDate(value) {
	this.userData.bornDate = value;
}
function setEmail(value) {
	this.userData.email = value;
}
function setConfirmEmail(value) {
	this.userData.confirmEmail = value;
	if (this.userData.email !== this.userData.confirmEmail) {
		this.confirmEmail.noMatch = true;
	} else {
		this.confirmEmail.noMatch = false;
	}
}
function setGender(value) {
	this.userData.gender = value.id;
}
function setCurrentPassword(value) {
	this.userData.currentPassword = value;
}
function setNewPassword(value) {
	if (value) {
		this.password.required = true;
	} else {
		this.password.required = false;
	}
	this.userData.newPassword = value;
}
function setConfirmPassword(value) {
	this.userData.confirmPassword = value;
	if (value) {
		if (this.userData.newPassword === this.userData.confirmPassword) {
			this.password.noMatch = false;
			this.password.required = false;
		} else {
			this.password.noMatch = true;
			this.password.required = false;
		}
	}
	if (!value) {
		if (this.password.new) {
			this.password.required = true;
			this.password.noMatch = false;
		} else {
			this.password.noMatch = false;
			this.password.required = false;
		}
	}
}
function selectAllBranchOffices() {
	if (!this.allBranchOffice) {
		this.userData.branchOffices = [];
	} else {
		this.userData.branchOffices = this.branchOffices.map(el => el.id);
	}
}

async function save() {
	const method = this.id ? 'put' : 'post';
	const userData = {
		flag_supervisor: this.userData.typeUser,
		name: this.userData.name,
		lastname: this.userData.lastName,
		email: this.userData.email,
		gender: this.userData.gender.id,
		date_birth: this.userData.bornDate,
		subsidiaries: this.userData.branchOffices,
		old_password: this.userData.currentPassword,
		password: this.userData.newPassword,
		url_image: this.userData.imageUrl,
	};
	const url = this.id ? `housemaid/${this.id}` : 'housemaid';
	await this.$http[method](url, userData);
	this.showNotification('La información se guardó exitosamente', 'success');
	this.$router.push('/users');
}
function activeSaveButton() {
	return this.userData.branchOffices.length === 0;
}
function data() {
	return {
		id: '',
		namePlaceholder: 'Ingrese los nombres',
		lastNamePlaceholder: 'Ingrese los apellidos',
		bornDate: {
			bornDate: '',
			type: 'date',
		},
		email: {
			placeholder: 'Ingrese su correo',
			type: 'email',
		},
		confirmEmail: {
			placeholder: 'Confirme su correo',
			type: 'email',
			noMatch: false,
		},
		genderLabel: 'Género',
		genders: [
			{ id: 1, text: 'Hombre' },
			{ id: 2, text: 'Mujer' },
		],
		password: {
			type: 'password',
			noMatch: false,
			currentNoMatch: false,
			required: false,
			disabledPassword: false,
			disabledNewPassword: false,
		},
		allBranchOffice: false,
		branchOffices: [],
		userData: {
			branchOffices: [],
			typeUser: '',
			imageUrl: helperData.preimageUrl,
		},
		disabledSaveButton: '',
		previewImage: '',
	};
}

export default {
	name: 'users-new',
	components: {
		InputText,
		SelectButton,
		FileUploadContainer,
	},
	created,
	data,
	computed: {
		activeSaveButton,
	},
	methods: {
		setTypeUser,
		setName,
		setLastName,
		setBornDate,
		setEmail,
		setConfirmEmail,
		setGender,
		setCurrentPassword,
		setNewPassword,
		setConfirmPassword,
		selectAllBranchOffices,
		save,
		load,
	},
	mixins: mixin,
};
</script>

<style lang="scss" scoped>
	.new-user-upload-fail {
		background-color: map-get($colors, delete-item);
	}
	.new-user-upload-success {
		background-color: map-get($colors, default-green);
	}
    .new-users-header {
        color: map-get($colors, label-bold);
        font-size: map-get($sizes, fourteen);
        font-weight: map-get($weights, w-six);
		margin-bottom: 9px;
        text-align: left;
    }
    .new-users-charges-type {
		display: flex;
        justify-content: left;
        margin-bottom: 15px;
        button {
            background-color: white;
            box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
            height: 76px;
            margin-right: 11px;
			width: 118px;
			.img-superviser {
				background-image: url('../../../static/img/superviser-grey.png');
				background-position: 2px;
				height: 31px;
				margin: auto;
				width: 40px;
			}
			.img-housemaid {
				background-image: url('../../../static/img/housemaid-grey.png');
				background-position: 8px;
				height: 31px;
				margin: auto;
				width: 40px;
				
			}
			span {
				color: map-get($colors, grey-slate);
			}

			&.active {
				background-color: map-get($colors, default-skyblue);
				.img-superviser {
					background-image: url('../../../static/img/superviser-white.png');
				}
				.img-housemaid {
					background-image: url('../../../static/img/housemaid-white.png');
				}
				span {
					color: white;
				}
			}
		}
    }
    .new-users-text {
        margin-bottom: 30px;
	}
	.new-users-form {
		label {
			float: left;
		}
		.flex {
			margin-bottom: 10px;
		}
		.new-users-password {
			color: map-get($colors, default-red);
			float: left;
		}
		.new-users-branch-offices {
			margin-bottom: 0;
			padding: 0;
			max-width: 160px;
			min-width: 150px;
		}
		.new-users-save {
			background-color: map-get($colors, default-skyblue);
			box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
			color: white;
			font-size: map-get($sizes, twelve);
			font-weight: map-get($weights, w-six);
			height: 38px;
			width: 164px;
		}
		.new-user-file-upload {
			height: 185px;
			width: 610px;
			display: flex;
			justify-content: center;
			align-content: center;
		}
	}
</style>



// WEBPACK FOOTER //
// Create.vue?3ebef5d8